import Component from '@glimmer/component';

import type { BadgeType } from '../../../types/components/prism/badge.ts';
import type { IconName } from '../../../types/components/prism/icon.ts';
import type { IconFlagCode } from '../../../types/components/prism/icon-flag.ts';
import PrismBadge from '../badge.gts';
import PrismIcon from '../icon.gts';
import PrismIconFlag from '../icon-flag.gts';
import PrismTooltip from '../tooltip.gts';

interface UnsafeArgs {
  unsafe_className?: string;
  unsafe_isLink?: boolean;
  unsafe_subLabel?: string;
}

interface PrismComboSelectInputOptionSignature {
  Args: UnsafeArgs & {
    badge?: string;
    badgeType?: BadgeType;
    disabled?: boolean;
    disabledMessage?: string;
    icon?: IconName;
    iconFlag?: IconFlagCode;
    label: string;
    selected: boolean;
  };
}

export default class PrismComboSelectInputOption extends Component<PrismComboSelectInputOptionSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get disabledMessage() {
    return this.args.disabled ? this.args.disabledMessage : undefined;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconColor() {
    return this.args.disabled ? 'disabled' : undefined;
  }

  <template>
    <div
      class="prism-combo-select-input__option-content
        {{if @unsafe_className @unsafe_className}}"
    >
      {{#if @icon}}
        <PrismIcon @color={{this.iconColor}} @name={{@icon}} @size="small" />
      {{/if}}
      {{#if @iconFlag}}
        <PrismIconFlag @code={{@iconFlag}} @size="small" />
      {{/if}}
      {{#if @unsafe_subLabel}}
        <div class="option__unsafe-sub-label-container">
          <p class="text-300--regular option__label truncate" title={{@label}}>
            {{@label}}
          </p>
          <p
            class="text-200--regular option__unsafe-sub-label line-clamp-2"
            title={{@unsafe_subLabel}}
          >
            {{@unsafe_subLabel}}
          </p>
        </div>
      {{else}}
        <p
          class="text-300--regular option__label truncate"
          title={{@label}}
        >{{@label}}</p>
      {{/if}}
      {{#if @badge}}
        <PrismBadge @type={{if @badgeType @badgeType "info"}}>
          {{@badge}}
        </PrismBadge>
      {{/if}}
      {{#if @unsafe_isLink}}
        <PrismIcon @name="link-out" @size="small" />
      {{/if}}
      {{#if @selected}}
        <PrismIcon @color={{this.iconColor}} @name="checkmark" @size="small" />
      {{/if}}

      {{#if this.disabledMessage}}
        <PrismTooltip @side="right" @text={{this.disabledMessage}} />
      {{/if}}
    </div>
  </template>
}
